export default __webpack_public_path__ + "static/media/quality.50085781.jpg";